import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as siteSearchActions from '@redux/modules/siteSearch';
import {
  KeywordFilter,
  SectionsFilter,
} from '@structures/SearchFilters';
import SearchFilterLeftRail from '@structures/SearchFilterLeftRail';

class SearchFilters extends React.Component {
  constructor(props) {
    super(props);

    const { dispatch } = this.props;

    this.siteSearchActions = bindActionCreators(siteSearchActions, dispatch);
  }

  render() {
    const {
      filtersOptions,
      filtersValues,
    } = this.props;

    const {
      filtersAppendOrRemove,
      filtersUpdate,
    } = this.siteSearchActions;

    return (
      <SearchFilterLeftRail>
        <KeywordFilter
          filterUpdate={filtersUpdate}
          filterValue={filtersValues.keyword}
          headerText="Refine results by"
          placeholder="Keyword"
        />
        <SectionsFilter
          filtersAppendOrRemove={filtersAppendOrRemove}
          filterOptions={filtersOptions}
          filtersUpdate={filtersUpdate}
          filterValue={filtersValues.section}
        />
      </SearchFilterLeftRail>
    );
  }
}

SearchFilters.propTypes = {
  dispatch: PropTypes.func.isRequired,
  filtersOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  filtersValues: PropTypes.shape({
    keyword: PropTypes.string,
    section: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};

SearchFilters.displayName = 'SearchFilters';

export default connect()(SearchFilters);
